<template>
  <el-dialog
    custom-class="chat-robot-dialog common-dialog"
    :fullscreen="true"
    :visible.sync="showDialog"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @opened="onOpen"
    @closed="onClose"
  >
    <div class="main-area">
      <action-bar
        ref="actionBar"
        @onBack="onBackClick"
        @onModelChanged="onModelChanged"
      ></action-bar>
      <message-box ref="messageBox" :model="model"></message-box>
      <footer-bar @clearMessages="onClearMessage"></footer-bar>
    </div>
    <clearMessages
      :dialog-visible.sync="showClearMessageDialog"
      @clearSuccess="onClearSuccess"
    ></clearMessages>
  </el-dialog>
</template>

<script>
import actionbar from './components/actionbar.vue'
import messageBox from './components/messageBox.vue'
import clearMessages from './components/clearMessages.vue'
import footerBar from './components/footerBar.vue'
export default {
  name: 'ChatRobot',
  components: {
    ActionBar: actionbar,
    MessageBox: messageBox,
    ClearMessages: clearMessages,
    footerBar: footerBar
  },
  props: {
    dialogVisible: Boolean
  },
  data() {
    return {
      showDialog: false,
      showClearMessageDialog: false,
      model: null
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  methods: {
    onOpen() {
      this.$refs.actionBar.init()
      this.$refs.messageBox.init()
    },
    onBackClick() {
      this.showDialog = false
    },
    onClose() {
      this.$refs.messageBox.close()
    },
    onModelChanged(model) {
      this.model = model
    },
    onClearMessage() {
      this.showClearMessageDialog = true
    },
    onClearSuccess() {
      this.$refs.messageBox.clearMessages()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

.chat-robot-dialog {
  /deep/ &.el-dialog {
    .el-dialog__header {
      height: 0;
      padding: 0;
    }

    .el-dialog__body {
      height: 100%;
      display: flex;
      padding-top: 0;
      align-items: center;
      justify-content: center;
    }
  }

  .main-area {
    display: flex;
    flex-direction: column;
    width: var(--common-dialog-large-width);
    height: var(--main-area-real-height);
    min-height: var(--main-area-min-height);
  }
}

:global(.el-dialog.chat-robot-dialog) {
  
  @include adaptation(
    (
      --main-area-min-height: 582px
    )
  );
  --main-area-real-height: max(50vh, var(--main-area-min-height));

  background: transparent;
  box-shadow: none;
  margin: 0;
  backdrop-filter: blur(var(--base-size-8));
}
</style>
